/**
 * Workflow Store - Manages use case and workflow state
 *
 * ARCHITECTURE COMPLIANCE:
 * - Store has NO setters - only state
 * - All mutations happen via MutationManager called by Commands
 * - This is a read-only reactive store
 */

import { create } from 'zustand';
import { UseCaseType } from '../domains/genogram/models/UseCase';
import { WorkflowStep } from '../domains/genogram/models/Workflow';
import type { GenogramAssistantRole } from '../domains/genogram/models/AssistantRole';

export interface WorkflowState {
  selectedUseCase: UseCaseType | null;
  assistantRole: GenogramAssistantRole | null;
  currentStep: WorkflowStep | null;
  skippedSteps: string[];
  completedSteps: string[];
  // NO SETTERS - mutations via commands only
}

export const useWorkflowStore = create<WorkflowState>(() => ({
  selectedUseCase: null,
  assistantRole: null,
  currentStep: null,
  skippedSteps: [],
  completedSteps: []
}));

// Export getter function for use in commands
export const getWorkflowState = () => useWorkflowStore.getState();
